<template>
  <div id="app">
    <router-view />
    <g-footer />
  </div>
</template>

<script>
import GFooter from './components/BottomNav.vue'

export default {
  name: 'App',
  components: { GFooter }
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
html, body, #app {
  height: 100%;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: #f5f5f5;
  -webkit-font-smoothing: antialiased;
}
.vehicle { min-height: 100vh; background: #f5f5f5; }
.vehicle-content {
  padding-bottom: 60px;
}
</style>